var _rect, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOfBirthCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11.6016,
    width: 56,
    height: 39.8733,
    rx: 8,
    fill: "#D0D7E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2602 7.45798C39.7494 9.94716 41.1478 13.3232 41.1478 16.8435C41.1478 20.3637 39.7494 23.7398 37.2602 26.2289L30.0864 33.4027C28.8649 34.6242 26.8845 34.6242 25.663 33.4027L18.4892 26.2289C16 23.7397 14.6016 20.3636 14.6016 16.8434C14.6016 13.3232 16 9.94709 18.4892 7.45791C20.9784 4.96871 24.3544 3.57031 27.8747 3.57031C31.3949 3.57031 34.771 4.96876 37.2602 7.45798Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2.49208,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6641 17.2353C22.6641 14.3601 24.9948 12.0293 27.87 12.0293C30.7452 12.0293 33.076 14.3601 33.076 17.2353C33.076 20.1104 30.7452 22.4412 27.87 22.4412C24.9948 22.4412 22.6641 20.1104 22.6641 17.2353Z",
    fill: "#FCFAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 29.136,
    cy: 40.5372,
    rx: 6.5071,
    ry: 2.35363,
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOfBirthCheckLarge);
export default __webpack_public_path__ + "static/media/place_of_birth_check_large.5320631155bfce3b07d5afa570d3dbd7.svg";
export { ForwardRef as ReactComponent };